import styles from "./summary.module.css";

const TermsDisclaimer = () => {
  return (
    <>
      <section
        className={styles.keyTerms}
        aria-label="Key terms before you pay"
      >
        <div className={styles.keyTermsHead}>
          <span className={styles.keyTermsIcon}>📋</span>
          <span className={styles.keyTermsTitle}>Before you pay</span>
        </div>
        <dl className={styles.keyTermsList}>
          <div className={styles.keyTermRow}>
            <dt className={styles.keyTermLabel}>Your plan</dt>
            <dd className={styles.keyTermBody}>
              Your selected plan includes the Credits, features and subscription
              period shown at checkout.
            </dd>
          </div>
          <div className={`${styles.keyTermRow} ${styles.keyTermRequired}`}>
            <dt className={styles.keyTermLabel}>
              Credits <span className={styles.keyTermFlag}>Important</span>
            </dt>
            <dd className={styles.keyTermBody}>
              Credits unlock Talent profiles for recruitment opportunities and
              are subject to the Credit Terms in our Terms of Service. Unused
              Credits remain available while your plan is active and are treated
              in accordance with the Credit Terms when your plan ends.
            </dd>
          </div>
          <div className={styles.keyTermRow}>
            <dt className={styles.keyTermLabel}>Subscription &amp; renewal</dt>
            <dd className={styles.keyTermBody}>
              Annual plans run for the period stated at checkout and may renew
              automatically where applicable. Renewal details will be provided
              before renewal.
            </dd>
          </div>
          <div className={`${styles.keyTermRow} ${styles.keyTermRequired}`}>
            <dt className={styles.keyTermLabel}>
              Refunds <span className={styles.keyTermFlag}>Important</span>
            </dt>
            <dd className={styles.keyTermBody}>
              Purchases are eligible for a refund within 14 days, provided no
              more than 10% of the purchased Credits have been used — subject to
              our Refund Policy and applicable law.
            </dd>
          </div>
          <div className={styles.keyTermRow}>
            <dt className={styles.keyTermLabel}>Talent information</dt>
            <dd className={styles.keyTermBody}>
              Talent profiles may be de-identified until an authorised unlock.
              Access to identifying information is subject to the Terms of
              Service and applicable data-protection requirements.
            </dd>
          </div>
        </dl>
        <p className={styles.keyTermsTotal}>
          The total amount payable, including any applicable taxes or charges,
          is shown before payment.
        </p>
      </section>
    </>
  );
};

export default TermsDisclaimer;
